import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
// Brand tokens + fonts in a plain :root block. tixo-ui/demo/theme.css
// hides the brand tokens (chartreuse, ink, soft) inside Tailwind v4's
// @theme directive which raw browsers ignore — without this import the
// nav-bar glass, the "Matched" check, the signature stroke, etc. all
// fall back to inherited colors.
import './tokens.css'
import './main.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
